export enum ModalVariants {
    Fantasy = 'fantasy',
    Simple = 'simple',
}

export enum ModalPaddingSizes {
    Normal = 'normal',
    Large = 'large',
}

export enum ModalCloseButtonPositions {
    Corner = 'corner',
    Header = 'header',
}

export type TextAlignments = 'left' | 'center' | 'right';
